
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.112.297l4.667 2.61a2.355 2.355 0 011.198 2.061v5.063a2.354 2.354 0 01-1.198 2.062l-4.667 2.61a2.318 2.318 0 01-2.271 0l-4.667-2.61A2.354 2.354 0 01.977 10.03V4.968a2.354 2.354 0 011.197-2.06L6.841.297a2.318 2.318 0 012.271 0zm4.068 10.77a1.2 1.2 0 00.599-1.036V4.968a1.2 1.2 0 00-.6-1.034l-4.666-2.61a1.159 1.159 0 00-1.135 0L2.71 3.934a1.2 1.2 0 00-.599 1.034v5.063a1.2 1.2 0 00.599 1.035l4.667 2.61c.353.198.782.198 1.135 0l4.667-2.61z","fill":"#585858"}}),_c('path',{attrs:{"d":"M11.617 4.522l-3.29 1.842a.695.695 0 01-.7 0l-3.29-1.842a.58.58 0 00-.59 0 .589.589 0 00.022 1.026l3.29 1.842c.109.059.224.106.342.141v3.496c0 .325.261.588.583.588a.586.586 0 00.584-.588V7.5c.113-.031.223-.076.326-.133l3.29-1.842a.59.59 0 00.215-.794.581.581 0 00-.782-.233v.024z","fill":"#585858"}})])
          )
        }
      }
    